import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useI18n } from "../i18n";
import { LogIn, Mail, Lock, ShieldCheck, Languages } from "lucide-react";
import { Button } from "../components/ui/button";

export default function Login() {
  const { login } = useAuth();
  const { t, toggle } = useI18n();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const go = async (e) => {
    if (e) e.preventDefault();
    setBusy(true);
    await login(email || "s.alfarsi@acmecorp.com");
    navigate("/app/dashboard");
  };

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-4">
      <button onClick={toggle} className="absolute top-5 end-5 flex items-center gap-1.5 px-3 h-9 rounded-lg border border-slate-200 hover:bg-slate-50 text-sm font-medium text-slate-700">
        <Languages className="w-4 h-4" />{t("language")}
      </button>
      <div className="w-full max-w-md">
        <div className="flex flex-col items-center text-center mb-8">
          <div className="w-14 h-14 rounded-2xl bg-teal-700 flex items-center justify-center shadow-lg shadow-teal-700/20">
            <LogIn className="w-7 h-7 text-white" />
          </div>
          <h1 className="mt-5 text-3xl font-bold text-slate-900">{t("welcome")}</h1>
          <p className="mt-2 text-slate-500">{t("loginSub")}</p>
        </div>
        <div className="border border-slate-200 rounded-2xl p-6 shadow-sm">
          <button onClick={() => go()} className="w-full flex items-center justify-center gap-3 border border-slate-200 rounded-lg py-3 text-slate-700 font-medium hover:bg-slate-50 transition-colors">
            <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google" className="w-5 h-5" />
            {t("continueGoogle")}
          </button>
          <div className="flex items-center gap-4 my-5">
            <div className="flex-1 h-px bg-slate-200" /><span className="text-xs text-slate-400 font-medium">OR</span><div className="flex-1 h-px bg-slate-200" />
          </div>
          <form onSubmit={go} className="space-y-4">
            <div>
              <label className="block text-sm font-semibold text-slate-700 mb-1.5">{t("email")}</label>
              <div className="relative">
                <Mail className="absolute start-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
                <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" className="w-full ps-10 pe-3 py-2.5 border border-slate-200 rounded-lg text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-teal-600 focus:border-teal-600 transition" />
              </div>
            </div>
            <div>
              <div className="flex items-center justify-between mb-1.5">
                <label className="block text-sm font-semibold text-slate-700">{t("password")}</label>
                <span className="text-sm text-teal-700 font-medium cursor-pointer hover:underline">{t("forgot")}</span>
              </div>
              <div className="relative">
                <Lock className="absolute start-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
                <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className="w-full ps-10 pe-3 py-2.5 border border-slate-200 rounded-lg text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-teal-600 focus:border-teal-600 transition" />
              </div>
            </div>
            <Button type="submit" disabled={busy} className="w-full bg-teal-700 hover:bg-teal-800 text-white py-6 text-base font-semibold rounded-lg">{t("login")}</Button>
          </form>
        </div>
        <p className="text-center text-sm text-slate-500 mt-6">
          {t("noAccount")} <span className="text-teal-700 font-semibold cursor-pointer hover:underline" onClick={() => go()}>{t("createOne")}</span>
        </p>
        <div className="mt-6 flex items-center justify-center gap-2 text-xs text-slate-400">
          <ShieldCheck className="w-3.5 h-3.5" /><span>{t("demoNote")}</span>
        </div>
      </div>
    </div>
  );
}
